module.exports = __webpack_public_path__ + "static/media/premierOne.1ae3f9b7.svg";